unit View.Desoneracao_Icms.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils;

type
  TFViewDesoneracao_IcmsList = class(TForm)
    btNew: TButton;
    Desoneracao_IcmsDataset: TXDataWebDataSet;
    Desoneracao_IcmsDatasetdesoneracao_icms_id: TIntegerField;
    Desoneracao_IcmsDatasetnome: TStringField;
    Desoneracao_IcmsDatasetexcluido: TBooleanField;
    Desoneracao_IcmsDatasetinclusao: TDateTimeField;
    Desoneracao_IcmsDatasetalteracao: TDateTimeField;
    Desoneracao_IcmsDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewDesoneracao_IcmsList: TFViewDesoneracao_IcmsList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewDesoneracao_IcmsList }

procedure TFViewDesoneracao_IcmsList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewDesoneracao_IcmsList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewDesoneracao_IcmsList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewDesoneracao_IcmsList, AElementID, Result, @AfterCreate);
end;

procedure TFViewDesoneracao_IcmsList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewDesoneracao_IcmsList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewDesoneracao_IcmsList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Desoneracao_IcmsDataset.Connection.Model.DefaultSchema.FindEntityType(Desoneracao_IcmsDataset.EntitySetName),
      Desoneracao_IcmsDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewDesoneracao_IcmsList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('desoneracao_icms', 'active');
  TUtils.SetValorDicionarioClasses('tributacoes_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_tributacoes', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    Desoneracao_IcmsDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewDesoneracao_IcmsList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.desoneracao_icms.list.pagination.info');
  btNew := TButton.Create('view.desoneracao_icms.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.desoneracao_icms.list.table');
  cbPageSize := TComboBox.Create('view.desoneracao_icms.list.cbPageSize');
  edSearch := TEdit.Create('view.desoneracao_icms.list.search');
  lcPaginator := TListControl.Create('view.desoneracao_icms.list.pagination');
  Desoneracao_IcmsDataset := TXDataWebDataSet.Create(Self);
  Desoneracao_IcmsDatasetdesoneracao_icms_id := TIntegerField.Create(Self);
  Desoneracao_IcmsDatasetnome := TStringField.Create(Self);
  Desoneracao_IcmsDatasetexcluido := TBooleanField.Create(Self);
  Desoneracao_IcmsDatasetinclusao := TDateTimeField.Create(Self);
  Desoneracao_IcmsDatasetalteracao := TDateTimeField.Create(Self);
  Desoneracao_IcmsDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  Desoneracao_IcmsDataset.BeforeLoadDFMValues;
  Desoneracao_IcmsDatasetdesoneracao_icms_id.BeforeLoadDFMValues;
  Desoneracao_IcmsDatasetnome.BeforeLoadDFMValues;
  Desoneracao_IcmsDatasetexcluido.BeforeLoadDFMValues;
  Desoneracao_IcmsDatasetinclusao.BeforeLoadDFMValues;
  Desoneracao_IcmsDatasetalteracao.BeforeLoadDFMValues;
  Desoneracao_IcmsDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewDesoneracao_IcmsList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'desoneracao_icms_id';
      Title := 'desoneracao_icms_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    Desoneracao_IcmsDataset.SetParentComponent(Self);
    Desoneracao_IcmsDataset.Name := 'Desoneracao_IcmsDataset';
    Desoneracao_IcmsDataset.EntitySetName := 'Desoneracao_Icms';
    Desoneracao_IcmsDataset.Connection := DMConnection.ApiConnection;
    Desoneracao_IcmsDataset.Left := 72;
    Desoneracao_IcmsDataset.Top := 144;
    Desoneracao_IcmsDatasetdesoneracao_icms_id.SetParentComponent(Desoneracao_IcmsDataset);
    Desoneracao_IcmsDatasetdesoneracao_icms_id.Name := 'Desoneracao_IcmsDatasetdesoneracao_icms_id';
    Desoneracao_IcmsDatasetdesoneracao_icms_id.FieldName := 'desoneracao_icms_id';
    Desoneracao_IcmsDatasetdesoneracao_icms_id.Required := True;
    Desoneracao_IcmsDatasetnome.SetParentComponent(Desoneracao_IcmsDataset);
    Desoneracao_IcmsDatasetnome.Name := 'Desoneracao_IcmsDatasetnome';
    Desoneracao_IcmsDatasetnome.FieldName := 'nome';
    Desoneracao_IcmsDatasetnome.Required := True;
    Desoneracao_IcmsDatasetnome.Size := 255;
    Desoneracao_IcmsDatasetexcluido.SetParentComponent(Desoneracao_IcmsDataset);
    Desoneracao_IcmsDatasetexcluido.Name := 'Desoneracao_IcmsDatasetexcluido';
    Desoneracao_IcmsDatasetexcluido.FieldName := 'excluido';
    Desoneracao_IcmsDatasetinclusao.SetParentComponent(Desoneracao_IcmsDataset);
    Desoneracao_IcmsDatasetinclusao.Name := 'Desoneracao_IcmsDatasetinclusao';
    Desoneracao_IcmsDatasetinclusao.FieldName := 'inclusao';
    Desoneracao_IcmsDatasetalteracao.SetParentComponent(Desoneracao_IcmsDataset);
    Desoneracao_IcmsDatasetalteracao.Name := 'Desoneracao_IcmsDatasetalteracao';
    Desoneracao_IcmsDatasetalteracao.FieldName := 'alteracao';
    Desoneracao_IcmsDatasetexclusao.SetParentComponent(Desoneracao_IcmsDataset);
    Desoneracao_IcmsDatasetexclusao.Name := 'Desoneracao_IcmsDatasetexclusao';
    Desoneracao_IcmsDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Desoneracao_IcmsDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    Desoneracao_IcmsDataset.AfterLoadDFMValues;
    Desoneracao_IcmsDatasetdesoneracao_icms_id.AfterLoadDFMValues;
    Desoneracao_IcmsDatasetnome.AfterLoadDFMValues;
    Desoneracao_IcmsDatasetexcluido.AfterLoadDFMValues;
    Desoneracao_IcmsDatasetinclusao.AfterLoadDFMValues;
    Desoneracao_IcmsDatasetalteracao.AfterLoadDFMValues;
    Desoneracao_IcmsDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
